import { render, staticRenderFns } from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=template&id=55b87ebd&scoped=true"
import script from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=script&lang=ts"
export * from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b87ebd",
  null
  
)

export default component.exports